import PropTypes from 'prop-types'
import Joyride, { STATUS } from 'react-joyride'
import JoyrideMessage from './JoyrideMessage'
import JoyrideStyles from './JoyrideStyles'

// #dimension-match-breakdown
// #matching-profile-match-score-card

export const MATCHING_PROFILE_INTRO_STEPS_CONFIG = [
  {
    id: 'matching-profile-intro-1',
    target: '#matching-profile-match-score-card',
    placement: 'right-start',
    title: 'discover.assistant_onboarding.9.title',
    description: 'discover.assistant_onboarding.9.description',
    ctaTitle: 'discover.assistant_onboarding.9.cta'
  },
  {
    id: 'matching-profile-intro-2',
    target: '#dimension-match-breakdown',
    placement: 'right-start',
    title: 'discover.assistant_onboarding.10.title',
    description: 'discover.assistant_onboarding.10.description',
    ctaTitle: 'discover.assistant_onboarding.10.cta'
  },
  {
    id: 'matching-profile-intro-4',
    target: '#dimension-high-fit',
    placement: 'right-start',
    title: 'discover.assistant_onboarding.11.title',
    description: 'discover.assistant_onboarding.11.description',
    ctaTitle: 'discover.assistant_onboarding.11.cta',
    isCtaPulsing: true
  }
]

const steps = MATCHING_PROFILE_INTRO_STEPS_CONFIG.map(
  ({ target, placement, title, description }) => ({
    target,
    content: <JoyrideMessage title={title} description={description} />,
    placement,
    disableBeacon: true
  })
)

export const MATCHING_PROFILE_PART_TWO_STEPS_CONFIG = [
  {
    id: 'matching-profile-part2-1',
    target: '#dimension-middle-fit',
    placement: 'right-start',
    title: 'discover.assistant_onboarding.12.title',
    description: 'discover.assistant_onboarding.12.description'
  }
]

const STEPS_PART_TWO = [
  MATCHING_PROFILE_PART_TWO_STEPS_CONFIG.map(
    ({ target, placement, title, description }) => ({
      target,
      content: <JoyrideMessage title={title} description={description} />,
      placement,
      disableBeacon: true
    })
  )
]

export const MATCHING_PROFILE_PART_THREE_STEPS_CONFIG = [
  {
    id: 'matching-profile-part3-1',
    target: '#matching-profile-chances-risks',
    placement: 'right-start',
    title: 'discover.assistant_onboarding.13.title',
    description: 'discover.assistant_onboarding.13.description',
    ctaTitle: 'discover.assistant_onboarding.13.cta'
  },
  {
    id: 'matching-profile-part3-2',
    target: null,
    title: 'discover.assistant_onboarding.14.title',
    description: 'discover.assistant_onboarding.14.description',
    ctaTitle: 'discover.assistant_onboarding.14.cta'
  }
]

const STEPS_PART_THREE = MATCHING_PROFILE_PART_THREE_STEPS_CONFIG.map(
  ({ target, placement, title, description }) => ({
    target,
    content: <JoyrideMessage title={title} description={description} />,
    placement,
    disableBeacon: true
  })
)

const MatchingProfileJoyride = ({ run, onClose }) => (
  <Joyride
    steps={steps}
    run={run}
    continuous
    showProgress
    styles={{
      tooltip: {
        maxWidth: '280px'
      },
      ...JoyrideStyles,
      options: {
        zIndex: 10000
      }
    }}
    locale={{
      last: 'Dimension entdecken',
      skip: 'Überspringen',
      next: 'Weiter',
      back: 'Zurück'
    }}
    callback={({ status, index, step }) => {
      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        onClose?.()
      }
    }}
  />
)

export const MatchingProfileJoyridePartTwo = ({ run, onClose, uxStep }) => {
  const steps = STEPS_PART_TWO[uxStep] || []
  if (!steps.length || uxStep == null) return null
  return (
    <Joyride
      steps={STEPS_PART_TWO[uxStep]}
      run={run}
      continuous
      showProgress
      styles={{
        tooltip: {
          maxWidth: '280px'
        },
        ...JoyrideStyles,
        options: {
          zIndex: 10000
        }
      }}
      locale={{
        last: 'Dimension entdecken',
        skip: 'Überspringen',
        next: 'Weiter',
        back: 'Zurück'
      }}
      callback={({ status, index, step }) => {
        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
          onClose?.()
        }
      }}
    />
  )
}

export const MatchingProfileJoyridePartThree = ({ run, onClose }) => (
  <Joyride
    steps={STEPS_PART_THREE}
    run={run}
    continuous
    showProgress
    styles={{
      tooltip: {
        maxWidth: '280px'
      },
      ...JoyrideStyles,
      options: {
        zIndex: 10000
      }
    }}
    locale={{
      last: 'Weiter',
      skip: 'Überspringen',
      next: 'Weiter',
      back: 'Zurück'
    }}
    callback={({ status, index, step }) => {
      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        onClose?.()
      }
    }}
  />
)

MatchingProfileJoyride.propTypes = {
  run: PropTypes.bool.isRequired,
  onClose: PropTypes.func
}

export const MatchingProfileJoyridePartTwoProptypes = {
  run: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  uxStep: PropTypes.number
}

MatchingProfileJoyridePartTwo.propTypes = MatchingProfileJoyridePartTwoProptypes

export const MatchingProfileJoyridePartThreeProptypes = {
  run: PropTypes.bool.isRequired,
  onClose: PropTypes.func
}

MatchingProfileJoyridePartThree.propTypes =
  MatchingProfileJoyridePartThreeProptypes

export default MatchingProfileJoyride
